export const extractValues = (items: any[], keys: string[]) =>
  items.map((item) => {
    const extracted: any = {};
    keys.forEach((key) => {
      extracted[key] = item[key];
    });
    return extracted;
  });
